import moment from 'moment';
import {
  RADIO_VALUE_YES,
  PRIMARY_APPLICANT,
  RADIO_VALUE_NO,
  OFFICER_DETAILS,
  TYPE_UK_ADDRESS,
  MONTH_FIELD,
  YEAR_FIELD,
  DATE_MOVE_SUFFIX
} from '../../../utils/constants';
import { getUkAddressFromCase, mapSelectedAddresses } from './addressPayloads';
import { REGULAR_TITLES } from '../../../routes/personDetailsSection/utils/personaDetailsUtils';
const VALUE_YES = 'Yes';
const VALUE_NO = 'No';

export const mapOfficerDetails = (data, state, isCustomer) => {
  const defaultApplicant = state.get(PRIMARY_APPLICANT);
  if (defaultApplicant && defaultApplicant.officer_id) {
    return defaultApplicant;
  }
  const applicant = getDefaultApplicant(data);
  if (applicant && applicant.length) {
    return createApplicant(applicant[0]);
  } else if (isCustomer) {
    return createApplicant(data);
  }
  return defaultApplicant;
};
export const getOfficersFromCase = (data, state) => {
  const officers = state.get(OFFICER_DETAILS) || [];
  if (data && data.officers && isValidOfficer(data.officers)) {
    data.officers.forEach((element, index) => {
      if (
        !checkPrimaryData(element.personal_details, data.applicant.personal_details) ||
        isSecondaryApplicant(data)
      ) {
        let filteredElement = createApplicant(element);
        filteredElement.ownCompany = filteredElement.percentPersonOwnCompany
          ? RADIO_VALUE_YES
          : RADIO_VALUE_NO;
        filteredElement = Object.assign({}, filteredElement, getMoveToDate(filteredElement));
        filteredElement = mapSelectedAddresses(
          filteredElement,
          state,
          index,
          filteredElement.addresses
        );
        officers.push(filteredElement);
      }
    });
  }
  return officers;
};
export const isValidOfficer = applicant => {
  if (applicant && applicant.length === 1) {
    return (
      (applicant[0].personal_details &&
        applicant[0].personal_details.name &&
        applicant[0].personal_details.name.first_name &&
        applicant[0].personal_details.name.last_name) ||
      (applicant[0].firstName && applicant[0].lastName)
    );
  }
  return true;
};
const createApplicant = applicant => {
  const primaryApplicant = {};
  if (applicant.personal_details) {
    primaryApplicant.firstName = applicant.personal_details.name.first_name;
    primaryApplicant.lastName = applicant.personal_details.name.last_name;
    primaryApplicant.middleName = applicant.personal_details.name.middle_name || '';
    primaryApplicant.dateOfBirth = generateDOB(applicant.personal_details.dob);
    primaryApplicant.officer_id = applicant.officer_id || '';
    primaryApplicant.authorisedSignatory = getAuthSignatories(applicant);
    primaryApplicant.companyDirector = getDirector(applicant);
    primaryApplicant.addresses = filterAddress(applicant.personal_details.addresses);
    primaryApplicant.residentialStatus = applicant.personal_details.residential_status;
    primaryApplicant.percentPersonOwnCompany = getPercentage(applicant);
    primaryApplicant.significantShareHolder = primaryApplicant.percentPersonOwnCompany
      ? RADIO_VALUE_YES
      : RADIO_VALUE_NO;
  }
  return Object.assign({}, primaryApplicant, getGenderTitle(applicant.personal_details.name.title));
};

export const getGenderTitle = value => {
  if (value) {
    const splitedString = value.toLowerCase().split('');
    splitedString[0] = splitedString[0].toUpperCase();
    const title = splitedString.join('');
    if (REGULAR_TITLES.indexOf(title) === -1) {
      return { title: 'Other', titleOther: title };
    }
    return { title: title };
  }
  return '';
};
const getDirector = applicant => {
  const director =
    applicant &&
    applicant.business_relationship &&
    applicant.business_relationship.director &&
    applicant.business_relationship.director === RADIO_VALUE_NO
      ? VALUE_NO
      : VALUE_YES;
  if (director === VALUE_YES) {
    return director;
  }
  return getMember(applicant);
};
const getMember = applicant =>
  applicant &&
  applicant.business_relationship &&
  applicant.business_relationship.member &&
  applicant.business_relationship.member === RADIO_VALUE_NO
    ? VALUE_NO
    : VALUE_YES;
const getAuthSignatories = applicant =>
  applicant && applicant.auth_signatory && applicant.auth_signatory === RADIO_VALUE_NO
    ? VALUE_NO
    : VALUE_YES;
const getPercentage = applicant =>
  applicant && applicant.shareholder && applicant.shareholder.percentage
    ? applicant.shareholder.percentage
    : '';
const getDefaultApplicant = data =>
  data.officers && data.officers.length > 0
    ? data.officers.filter(v => v.applier === RADIO_VALUE_YES)
    : [];
const filterAddress = addresses =>
  addresses.map(address => {
    if (!address.effective_period.to) {
      delete address.effective_period.to;
    }
    address.effective_period.from = moment(address.effective_period.from).format();
    return getUkAddressFromCase(address);
  });
const getDateOfBirth = dob => {
  if (dob) {
    const splitedDate = dob.split('-');
    return {
      dateField: splitedDate[2],
      monthField: splitedDate[1],
      yearField: splitedDate[0]
    };
  }
  return {};
};
export const mapPrimaryApplicant = (data, id) => {
  data.officer_id = id;
  return data;
};
export const generateDOB = date => {
  const RANGE_FOUR = 4;
  const RANGE_SIX = 6;
  const RANGE_EIGHT = 8;
  return date.indexOf('-') > -1
    ? getDateOfBirth(date)
    : getDateOfBirth(
        `${date.substring(0, RANGE_FOUR)}-${date.substring(RANGE_FOUR, RANGE_SIX)}-${date.substring(
          RANGE_SIX,
          RANGE_EIGHT
        )}`
      );
};
export const generateApplicant = (values, applicant) => {
  applicant.ownCompany = values.control;
  if (values.control === RADIO_VALUE_YES) {
    applicant.percentPersonOwnCompany = values.controlling_percentage;
  }
  if (applicant.percentPersonOwnCompany && values.control === RADIO_VALUE_NO) {
    delete applicant.percentPersonOwnCompany;
  }
  return applicant;
};
export const getControlBusinessValues = (_businessData, applicant) => {
  const initialValues = {};
  if (applicant.percentPersonOwnCompany) {
    initialValues.controlling_percentage = applicant.percentPersonOwnCompany;
    initialValues.control = RADIO_VALUE_YES;
  } else if (isValidOfficer([applicant])) {
    initialValues.control = RADIO_VALUE_NO;
  }
  return initialValues;
};
const getMoveToDate = officer => {
  let dateMove = {};
  officer.addresses.forEach((element, index) => {
    dateMove = Object.assign(
      {},
      dateMove,
      generateMoveToDate(element.effective_period.from, index)
    );
  });
  return dateMove;
};
const generateMoveToDate = (fromDate, index) => {
  const date = new Date(fromDate);
  const baseType = `${TYPE_UK_ADDRESS}${index > 0 ? index : ''}`;
  const month = date.getMonth() + 1;
  return {
    [`${baseType}${DATE_MOVE_SUFFIX}`]: {
      [`${baseType}${MONTH_FIELD}`]: `${month.toString().length === 2 ? month : `0${month}`}`,
      [`${baseType}${YEAR_FIELD}`]: date.getFullYear()
    }
  };
};
const isSecondaryApplicant = caseDetail =>
  caseDetail && caseDetail.applicant && caseDetail.applicant.joint_link_code
    ? caseDetail.applicant.joint_link_code
    : '';

const checkPrimaryData = (officer, primaryCaseData) => {
  return (
    officer.name.first_name.toUpperCase() === primaryCaseData.name.first_name.toUpperCase() &&
    officer.name.last_name.toUpperCase() === primaryCaseData.name.last_name.toUpperCase() &&
    !primaryCaseData.dob
  );
};
